import React, { useEffect } from "react"
import { Route } from "react-router-dom"
import { ComboBox } from "ksc-portal-common-components/shadcn"
import PropTypes from "prop-types"

const EntityDropdown = ({
  entities,
  entity_id,
  handleChange,
  loadIAM,
  history,
}) => {
  useEffect(() => {
    loadIAM()
  }, [])

  return (
    <div id="iam-entity-dropdown">
      <Route path="/iam">
        {!["entities"].some((el) =>
          history.location.pathname.toLowerCase().includes(el)
        ) &&
          entity_id && (
            <ComboBox
              options={
                entities.length
                  ? entities
                  : [
                      {
                        value: "0000",
                        label: "Master",
                      },
                    ]
              }
              onChange={(currentValue) =>
                currentValue &&
                handleChange({ target: { value: currentValue } })
              }
              defaultValue={entity_id}
              placeholder="Select entity..."
              emptyMessage="No entities found."
              heading="Entity"
              disabled={!entities.length}
              aria-label="Entity dropdown"
            />
          )}
      </Route>
    </div>
  )
}

EntityDropdown.propTypes = {
  entities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  entity_id: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  loadIAM: PropTypes.func.isRequired,
  history: PropTypes.shape({
    location: PropTypes.shape({ pathname: PropTypes.string }),
  }).isRequired,
}

EntityDropdown.defaultProps = {
  entity_id: null,
}

export default EntityDropdown
